module.exports = __webpack_public_path__ + "img/logo_cuba.149b1f79.jpg";